import React from "react";

const PersonCount = ({ value, onChange }) => {
  return (
    <div className="mb-3">
      <label className="block text-gray-700 font-semibold mb-1">
        Number of People
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full p-2 border rounded"
      >
        {[...Array(10).keys()].map((num) => (
          <option key={num + 1} value={num + 1}>
            {num + 1} Person{num > 0 ? "s" : ""}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PersonCount;
